import { render } from "./BaseWidget.vue?vue&type=template&id=133d244a&scoped=true"
import script from "./BaseWidget.vue?vue&type=script&lang=js"
export * from "./BaseWidget.vue?vue&type=script&lang=js"

import "./base-widget.scss?vue&type=style&index=0&id=133d244a&lang=scss&scoped=true"

import exportComponent from "/home/paperspace/thehrway-basic/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-133d244a"]])

export default __exports__